import { Flex, Spinner } from '@radix-ui/themes';
import usePitchListStore from 'components/sections/pitch-list/store/use-pitch-list-store';
import { MachineContext } from 'contexts/machine.context';
import { isFuture } from 'date-fns';
import { QueueType } from 'interfaces/i-queue-mode';
import { useContext, useMemo } from 'react';
import useMachineStatusStore from 'stores/use-machine-status-store';

export const QueueIndicator = (props: { pitchID: string }) => {
  const awaitFiringUntil = useMachineStatusStore(
    (s) => s.fireStateDates.awaitFiringUntil
  );

  const { lastPitchID } = useContext(MachineContext);
  const queuePitchIDs = usePitchListStore((s) => s.queuePitchIDs);
  const queueType = usePitchListStore((s) => s.queueType);

  const content = useMemo(() => {
    if (isFuture(awaitFiringUntil) && lastPitchID === props.pitchID) {
      return <Spinner />;
    }

    // not the right modes
    if (queueType === QueueType.ShuffleEach) {
      return null;
    }

    if (queueType === QueueType.RepeatOne) {
      return null;
    }

    const index = queuePitchIDs.findIndex((id) => id === props.pitchID);

    if (index === -1) {
      // not in queue
      return null;
    }

    return index + 1;
  }, [awaitFiringUntil, lastPitchID, props.pitchID, queueType, queuePitchIDs]);

  return (
    <Flex style={{ minWidth: '16px' }} justify="center" align="center">
      {content}
    </Flex>
  );
};
